var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center pa-2"},[_c('div',{staticClass:"text-body-1"},[_vm._t("default")],2),_c('v-spacer'),_c('div',[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }